import React, { useRef, useCallback } from 'react';

/**
 * Full-screen on mobile: shows the bill HTML inside the app in an iframe.
 * System print / Save as PDF only runs when the user taps the green button.
 */
const BillPrintFrameModal = ({ html, onClose }) => {
    const iframeRef = useRef(null);

    const triggerPrint = useCallback(() => {
        try {
            const w = iframeRef.current?.contentWindow;
            w?.focus();
            w?.print();
        } catch (e) {
            console.warn('Print failed:', e);
        }
    }, []);

    if (!html) return null;

    return (
        <div
            className="fixed inset-0 z-[70] flex flex-col bg-white sm:items-center sm:justify-center sm:bg-black/50 sm:p-4"
            role="dialog"
            aria-modal="true"
            aria-labelledby="bill-print-frame-title"
        >
            <div className="flex h-full w-full flex-col overflow-hidden bg-white sm:h-auto sm:max-h-[90dvh] sm:max-w-md sm:rounded-xl sm:border sm:border-stone-200 sm:shadow-2xl">
                <div
                    className="flex flex-shrink-0 items-center justify-between gap-2 border-b border-stone-200 bg-white px-4 py-3"
                    style={{ paddingTop: 'max(0.75rem, env(safe-area-inset-top, 0px))' }}
                >
                    <h2 id="bill-print-frame-title" className="text-base font-bold text-stone-900">
                        Bill
                    </h2>
                    <button
                        type="button"
                        onClick={onClose}
                        className="-mr-2 rounded-lg p-2 text-2xl leading-none text-stone-500 hover:bg-stone-100 hover:text-stone-800"
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>

                <iframe
                    ref={iframeRef}
                    title="Bill receipt"
                    srcDoc={html}
                    className="min-h-0 w-full flex-1 border-0 bg-white"
                />

                <div
                    className="flex flex-shrink-0 gap-2 border-t border-stone-200 bg-white p-3 sm:p-4"
                    style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom, 0px))' }}
                >
                    <button
                        type="button"
                        onClick={onClose}
                        className="flex-1 rounded-lg bg-stone-200 py-3 text-sm font-semibold text-stone-800 hover:bg-stone-300"
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        onClick={triggerPrint}
                        className="hidden sm:flex flex-1 rounded-lg bg-emerald-600 py-3 text-sm font-semibold text-white hover:bg-emerald-700 items-center justify-center"
                    >
                        Print / Save PDF
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BillPrintFrameModal;
